module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "epig"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Epi1"
  }, [_vm._v("    What mad pursuit? What struggle to escape?")]), _vm._v(" "), _c('p', {
    staticClass: "Epi1"
  }, [_vm._v("        What pipes and timbrels? What wild ecstasy?")]), _vm._v(" "), _c('p', {
    staticClass: "Epi"
  }, [_vm._v("                 —John Keats, “Ode on a Grecian Urn”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-542f3a64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 66
// module chunks = 0